const includes = <T>(haystack: T[], needle: T): boolean => haystack.indexOf(needle) > -1;

export {includes};
